import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { intlShape } from '../../../../components/prop-types';

import { LegacyInputTextComponent } from '../../../../components/prime-formik';
import FormikTextCopiable from '../../../../components/formik-components/FormikTextCopiable';
import { validationMessages } from '../../../../i18n/common';


const i18n = defineMessages({
  header: {
    id: 'file_import.header.active',
    defaultMessage: 'Activate Import File',
  },
});

const buildValidationSchema = formatMessage => (Yup.object().shape({
  confirmation_code: Yup
    .string()
    .required(formatMessage(validationMessages.required)),
  re_confirmation_code: Yup
    .string()
    .oneOf([Yup.ref('confirmation_code'), null], validationMessages.sameAs)
    .required(formatMessage(validationMessages.required)),
}));

const ActivateModal = (props) => {
  const {
    reject,
    confirm,
    modalOpen,
    intl: { formatMessage },
    def,
  } = props;
  const headerMessage = formatMessage(i18n.header);

  const initialValues = {
    confirmation_code: def.id,
    re_confirmation_code: '',
  };

  const validationSchema = buildValidationSchema(formatMessage);
  const dialogFooter = (
    <Fragment>
      <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
        {text => (
          <Button
            className="p-button-secondary"
            label={text}
            onClick={reject}
          />
        )}
      </FormattedMessage>
      &nbsp;
      <FormattedMessage id="actions.activate" defaultMessage="Activate">
        {text => (
          <Button label={text} type="submit" />
        )}
      </FormattedMessage>
    </Fragment>
  );
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={confirm}
      render={() => (
        <Form>
          <Dialog
            header={headerMessage}
            footer={dialogFooter}
            visible={modalOpen}
            onHide={reject}
            modal
          >
            <div className="form-group group-normalized">
              <FormattedMessage id="lbl.confirmation_code" defaultMessage="Confirmation code">
                {text => <label htmlFor="confirmation_code">{text}</label>}
              </FormattedMessage>
              <Field
                name="confirmation_code"
                keyValue={def.id}
                component={FormikTextCopiable}
                readOnly
              />
            </div>
            <div className="form-group group-normalized">
              <FormattedMessage id="lbl.confirmation_code_retype" defaultMessage="Please type the confirmation code">
                {text => <label htmlFor="re_confirmation_code">{text}</label>}
              </FormattedMessage>
              <div>
                <Field
                  name="re_confirmation_code"
                  component={LegacyInputTextComponent}
                />
              </div>
            </div>
          </Dialog>
        </Form>
      )}
    />
  );
};

ActivateModal.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  def: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(injectIntl(ActivateModal));
